import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { PureDataComponent } from '@aytm/lib/common/components/pure-component'
import { Map } from 'immutable'

import '@aytm/lib/rfd-ui/styles/advanced/toggle.scss'

const TOGGLE_WIDTH = 36
const TOGGLE_BORDER_WIDTH = 16

export default class Toggle extends PureDataComponent {
  static propTypes = {
    width: PropTypes.number,
    value: PropTypes.number,
    left: PropTypes.instanceOf(Map),
    right: PropTypes.instanceOf(Map),
    label: PropTypes.string,
    theme: PropTypes.string,
    toggleWidth: PropTypes.number,
    disabled: PropTypes.bool,
    onChange: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.setActive = this.setActive.bind(this)
    this.toggleClick = this.toggleClick.bind(this)
    this.setActiveState = this.setActiveState.bind(this)
    this.pinClick = this.pinClick.bind(this)
    this.pinCatch = this.pinCatch.bind(this)
    this.pinMove = this.pinMove.bind(this)
    this.pinRelease = this.pinRelease.bind(this)

    this.state = {
      active: props.value == props.right.get('value') ? 1 : 0,
      position: 0
    }

    this.pinCaught = false
    this.moveTimeout = null
    this.active = 0
    this.toggleWidth = props.toggleWidth ? props.toggleWidth : TOGGLE_WIDTH
  }

  componentDidMount() {
    super.componentDidMount()

    this.setState({
      active: this.props.value,
      position: this.props.value * (this.toggleWidth - TOGGLE_BORDER_WIDTH)
    })

    document.addEventListener('mouseup', this.pinRelease)
    document.addEventListener('mousemove', this.pinMove)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    super.UNSAFE_componentWillReceiveProps(nextProps)

    if (nextProps.value != this.props.value) {
      this.setActive(nextProps.value == nextProps.right.get('value') ? 1 : 0)
    }
  }

  setActive(val, position) {
    this.setState({
      active: val,
      position: position ? position : val * (this.toggleWidth - TOGGLE_BORDER_WIDTH)
    })
  }

  toggleClick(event) {
    this.setActiveState(event.nativeEvent.offsetX > this.toggleWidth / 2 ? 1 : 0)
  }

  setActiveState(val) {
    const { left, right, onChange } = this.props
    if ('function' == typeof onChange) {
      if (val != this.state.active) onChange(val ? right.get('value') : left.get('value'))
      this.active = val
    }
    this.setActive(val)
  }

  pinClick(event) {
    event.preventDefault()
    event.stopPropagation()
    return false
  }

  pinCatch() {
    this.pinCaught = true
  }

  pinMove(event) {
    if (this.pinCaught) {
      const refLeft = this.refToggle.getBoundingClientRect().left
      const x = Math.min(Math.max(event.clientX - refLeft, 0), this.toggleWidth)
      this.active = event.clientX > refLeft + this.toggleWidth / 2 ? 1 : 0
      const _this = this

      clearTimeout(this.moveTimeout)
      this.moveTimeout = setTimeout(() => {
        if (_this.pinCaught)
          _this.setState({ position: (x * (_this.toggleWidth - TOGGLE_BORDER_WIDTH)) / _this.toggleWidth })
      }, 15)
    }
  }

  pinRelease() {
    if (this.pinCaught) {
      this.pinCaught = false
      this.setActiveState(this.active)
    }
  }

  render() {
    const { width, theme, left, right, label, disabled } = this.props
    const { active, position } = this.state

    return (
      <div
        className={classNames('rfd-ui-toggle', {
          [`rfd-ui-toggle-theme-${theme}`]: theme,
          'rfd-ui-toggle-active': active
        })}
      >
        {!label && (
          <div
            className={classNames('rfd-ui-toggle-button-label', {
              'rfd-ui-toggle-button-label-active': !active,
              'rfd-ui-toggle-button-label-disabled': disabled
            })}
            style={{ width: width ? width : 'none' }}
            onClick={
              !disabled
                ? () => {
                    this.setActiveState(0)
                  }
                : undefined
            }
          >
            <div className="rfd-ui-toggle-button">
              <i className={left.get('icon')} />
              <span className="rfd-ui-toggle-button-text">{left.get('label')}</span>
            </div>
          </div>
        )}
        <span
          className={classNames('rfd-ui-toggle-inner', { 'rfd-ui-toggle-inner-disabled': disabled })}
          ref={this.saveRef('Toggle')}
        >
          <span
            className={'rfd-ui-toggle-inner-m'}
            onClick={!disabled ? this.toggleClick : undefined}
            style={{ width: this.toggleWidth }}
          >
            <a
              href="#"
              className="rfd-ui-toggle-pin"
              ref={this.saveRef('TogglePin')}
              draggable={false}
              style={{ left: position }}
              onClick={this.pinClick}
              onMouseDown={!disabled ? this.pinCatch : undefined}
              onMouseUp={!disabled ? this.pinRelease : undefined}
            >
              <span className={classNames('rfd-ui-toggle-pin-c', { active: this.pinCaught })} />
            </a>
          </span>
        </span>
        {!label && (
          <div
            className={classNames('rfd-ui-toggle-button-label', {
              'rfd-ui-toggle-button-label-active': active,
              'rfd-ui-toggle-button-label-disabled': disabled
            })}
            style={{ width: width ? width : 'none' }}
            onClick={
              !disabled
                ? () => {
                    this.setActiveState(1)
                  }
                : undefined
            }
          >
            <div className="rfd-ui-toggle-button right">
              <i className={right.get('icon')} />

              <span className="rfd-ui-toggle-button-text">{right.get('label')}</span>
            </div>
          </div>
        )}
        {label && (
          <div className={'rfd-ui-toggle-label'}>
            <span
              className="rfd-ui-toggle-label-text"
              onClick={
                !disabled
                  ? () => {
                      this.setActiveState(active ? 0 : 1)
                    }
                  : undefined
              }
            >
              {label}
            </span>
          </div>
        )}
      </div>
    )
  }
}
